module.exports = __webpack_public_path__ + "img/stock2.2f949744.png";